import { Input } from '@appkit4/react-components/field';
import { Button } from '@appkit4/react-components/button';
import { useGetAccountingMethods } from '../api/generated/endpoint';
import type { AccountingMethodResponse } from '../api/generated/models';

export interface TaxPoolsFormData {
    shortName: string;
    description: string;
    calcType: string;
    rate: string | number;
}

interface TaxPoolsFormProps {
    formData: TaxPoolsFormData;
    onChange: (field: keyof TaxPoolsFormData, value: string | number) => void;
    isDefaultHMRC?: boolean;
}

const TaxPoolsForm = ({
    formData,
    onChange,
    isDefaultHMRC,
}: TaxPoolsFormProps) => {
    const { data: accountingMethods } = useGetAccountingMethods();
    const methods = (accountingMethods ?? []) as AccountingMethodResponse[];

    return (
        <div className="tax-pools-form">
            <Input
                type={'text'}
                title={'Pool Name'}
                value={formData.shortName}
                required={true}
                disabled={isDefaultHMRC}
                onChange={(value: string) => onChange('shortName', value)}
            />
            <Input
                type={'text'}
                title={'Pool Description'}
                value={formData.description}
                required={true}
                disabled={isDefaultHMRC}
                onChange={(value: string) => onChange('description', value)}
            />
            <div className="calc-type-group">
                <div className="calc-type-label">Choose Calculation Type</div>
                <div className="calc-type-buttons">
                    {methods.map((method) => {
                        const isActive =
                            formData.calcType === String(method.calcTypeId);
                        return (
                            <Button
                                key={method.calcTypeId}
                                kind={isActive ? 'primary' : 'secondary'}
                                type="button"
                                className={'calc-type-button'}
                                onClick={() =>
                                    onChange(
                                        'calcType',
                                        String(method.calcTypeId)
                                    )
                                }
                            >
                                {method.name}
                            </Button>
                        );
                    })}
                </div>
            </div>
            <Input
                type="number"
                title={'Pool Rate'}
                value={formData.rate}
                required={true}
                onChange={(value: string) => onChange('rate', value)}
            />
        </div>
    );
};

export default TaxPoolsForm;
